import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { TranslateService } from "@ngx-translate/core";
import { catchError, Observable } from "rxjs";
import { BaseService } from "../base.service";
import { NotificationService } from "../util/notification.service";
import { DocumentaryProofDCM } from "./model/documentary-proof-dcm.model";
import { _ErrorStateTracker } from "@angular/material/core";

@Injectable({
  providedIn: 'root'
})
export class DocumentaryProofDCMService extends BaseService {
  private mobilityUrl = environment.api.mobilityUrl;

  constructor(private httpClient: HttpClient, protected notificationService: NotificationService, protected translate: TranslateService,) {
    super(notificationService, translate);
  }

  downloadDocumentaryProofFile(documentaryProofId: number, documentaryProofFileId: number): Observable<any> {
    const url = `${this.mobilityUrl}/api/data-control-manager/v1/documentary-proofs/${documentaryProofId}/files/${documentaryProofFileId}/_download`;

    return this.httpClient.get(url, { responseType: 'arraybuffer' }).pipe(
      catchError(err => {
        if (err.status === 403) {
          console.error(`The agent doesn't have the permission to download documentary proof file`);
        }
        console.error(err);
        throw err;
      })
    );
  }

  validateDocumentaryProof(documentaryProofId: number, statusReason: string) {
    let params = null;
    if (statusReason) {
      params = new HttpParams().set('statusReason', statusReason);
    }
    return this.httpClient.post<DocumentaryProofDCM>(`${this.mobilityUrl}/api/data-control-manager/v1/documentary-proofs/${documentaryProofId}/_validate`, '', { params });
  }

  refuseDocumentaryProof(documentaryProofId: number, statusReason: string): Observable<DocumentaryProofDCM> {
    let params = null;
    if (statusReason) {
      params = new HttpParams().set('statusReason', statusReason);
    }
    return this.httpClient.post<DocumentaryProofDCM>(`${this.mobilityUrl}/api/data-control-manager/v1/documentary-proofs/${documentaryProofId}/_refuse`, '', { params });
  }
}
